import axiosIntsance from "@/apiServices/StrapiApi"

export default {

    async getBlogs() {

        let response = await axiosIntsance().get(`/aliff-blogs?populate=*`);

        return response;
    },

    async getBlog(payload) {

        const { id } = payload;

        let response = await axiosIntsance().get(`/aliff-blogs/${id}?populate=*`);

        return response;
    },

}


// WEBPACK FOOTER //
// ./src/apiServices/StrapiServices.js